import { createFileRoute } from '@tanstack/react-router'
import { AnexBroadbandSignUp } from '@anex/common'
import '@anex/common/dist/index.css'

export const Route = createFileRoute('/sign-up')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="content-container p-5">
      <AnexBroadbandSignUp
        anexApiBaseUrl={(window as any)['ANEX_API_ENDPOINT']}
        anexApiToken={(window as any)['ANEX_API_TOKEN']}
        wholesalerCode="ISPX"
        wholesalerName={WHOLESALERNAME}
        allowOpticommSale={true}
        allowVoipSale={true}
      />
    </div>
  )
}
